/* eslint-disable class-methods-use-this */

import React from 'react';
import PureComponent from 'react-pure-render/component';
import { connect } from 'react-redux';
import { replace } from 'redux-router';
import { logout, setHeader } from 'actions';

import Loading from 'components/common/Loading';

class LogoutPage extends PureComponent {
  componentWillMount() {
    this.props.setHeader(false);
    this.props.logout();
    // Artificial timeout to show you are being logged out
    setTimeout(() => {
      this.props.replace('/');
    }, 1500);
  }

  render() {
    return (
      <Loading withWrapper />
   );
  }
}

function mapStateToProps(/* state */) {
  return {
  };
}

export default connect(mapStateToProps, {
  logout,
  setHeader,
  replace,
})(LogoutPage);



// WEBPACK FOOTER //
// ./src/app/containers/LogoutPage.js